import '@futrli/ui-components/ui-styles/sass/base/bulma.scss?global';
import '@futrli/ui-components/ui-styles/sass/base/react-grid-layout.css?global';
import '@futrli/ui-components/ui-styles/sass/typography/fonts.scss?global';
import '@futrli/ui-components/ui-styles/sass/typography/typography.scss?global';
import 'react-resizable/css/styles.css?global';
import 'react-quill-new/dist/quill.snow.css?global';
import 'react-phone-input-2/lib/bootstrap.css?global';
import 'carbon-react/lib/style/fonts.css';
import CarbonProvider from 'carbon-react/lib/components/carbon-provider';
import sageTheme from 'carbon-react/lib/style/themes/sage';
import TokensWrapper from 'carbon-react/lib/components/tokens-wrapper';
// import GlobalStyle from "carbon-react/lib/style/global-style";
import './index.scss';

import React from 'react';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';

import { LocalisationProvider } from '@futrli/localisation';
import { LocalisedConstantsContextProvider } from '@futrli/localisation/core/localised-constants-context';
import { UIComponentsProvider } from '@futrli/ui-components';

import { App } from './app/app';
import { initErrorTracker, injectLibs } from './core/setup';
import { initBrowserColorModeListener } from './core/browse-color-mode';
import { store } from './core/redux-utils/store';
import { BrowserRouter } from 'react-router-dom';

injectLibs();
initErrorTracker();
initBrowserColorModeListener();

const container = document.getElementById('futrli');
const root = createRoot(container as HTMLElement);

/**
 * @todo: the BrowserRouter component *must* be inside the other providers
 * because react-intl is killing the context and stopping the routes
 * from updating. Raising a bug with react-intl.
 *
 * react-intl doesn't seem to be in active development anymore so
 * work to replace with https://github.com/projectfluent/fluent
 * or similar should be considered.
 *
 * @see https://github.com/FUTRLI/localisation/issues/11
 */
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <LocalisationProvider>
        <LocalisedConstantsContextProvider>
          <UIComponentsProvider>
            <CarbonProvider theme={sageTheme}>
              {/* <GlobalStyle /> */}
              <TokensWrapper>
                <App />
              </TokensWrapper>
            </CarbonProvider>
          </UIComponentsProvider>
        </LocalisedConstantsContextProvider>
      </LocalisationProvider>
    </Provider>
  </BrowserRouter>
);
